import { render } from "./V4LoadingEventsAndReminder.vue?vue&type=template&id=4ae94e3c"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__